/* eslint-disable */
import React, { useLayoutEffect, useRef, useState } from 'react';
import { Ico } from './ShellIcons';
import { OptionRows } from './FilterField';
import { Seg, Chips, Toggle } from './InlineFields';
import fb from './filterBar.module.css';
import pop from './popovers.module.css';

// ============================================================
// MoreFilters — "every filter, in one place". Shown (via the hasMore class)
// once the bar has collapsed something; on a phone it is the only filter
// entry and the popover docks to the bottom of the screen. It lists EVERY
// filter of the bar (not only the collapsed ones) so nothing is unreachable.
// One scroller (the body); each filter is a block with its heading and how
// many of it are on; chip / segment groups wrap; the list fields inside never
// scroll on their own; the popover opens to the left when the button sits too
// close to the right edge (David, 11.10).
// ============================================================

const onCount = (f) => {
  if (f.type === 'toggle') return f.value ? 1 : 0;
  if (f.type === 'seg' || f.type === 'chips') return f.value != null && f.defaultValue !== undefined && f.value !== f.defaultValue ? 1 : 0;
  return f.value && f.value.size ? f.value.size : 0;
};

export default function MoreFilters({ fields, open, onToggle, onClose, onClearAll, activeCount, label }) {
  const listable = fields.filter((f) => f.type !== 'spec' && f.type !== 'custom');
  const wrap = useRef(null);
  const [right, setRight] = useState(false);
  useLayoutEffect(() => {
    if (!open || !wrap.current) return;
    const r = wrap.current.getBoundingClientRect();
    setRight(r.left + 380 > window.innerWidth - 12);
  }, [open]);
  return (
    <div ref={wrap} className={`${fb.ffw} ${fb.fmore}`} data-ffw="more">
      <button type="button" className={`${fb.ff} ${fb.ffMore} ${open ? fb.open : ''}`} onClick={(e) => { e.stopPropagation(); onToggle(); }} aria-expanded={open} title="Every filter — the ones that do not fit this width live here">
        <Ico name="filter" />
        <span className={fb.fl}>{label ? label : <><span className={fb.mo}>More</span><span className={fb.fi}>Filters</span></>}</span>
        {activeCount > 0 && <span className={`${fb.fn} ${fb.show}`}>{activeCount}</span>}
      </button>
      {open && (
        <div className={`${pop.fpop} ${pop.morePop} ${right ? pop.right : ''}`} data-shell-pop data-test="shell-more-pop" onClick={(e) => e.stopPropagation()}>
          <div className={pop.fpHead}><span className={pop.fpT}>All filters</span><span className={pop.fpN}>{activeCount > 0 ? <><b>{activeCount} on</b> · </> : null}every filter, in one place</span></div>
          <div className={pop.moreBody}>
            {listable.map((f) => {
              const title = f.label || f.alt || f.tag || f.key;
              const n = onCount(f);
              return (
                <section key={f.key} className={pop.moreBlock}>
                  {f.type === 'toggle' ? null : <div className={pop.moreHead}><b>{title}</b>{n ? <span>{n} on</span> : null}</div>}
                  {f.type === 'toggle' && <Toggle field={f} />}
                  {f.type === 'seg' && <Seg field={f} inner />}
                  {f.type === 'chips' && <Chips field={f} />}
                  {(!f.type || f.type === 'list') && <OptionRows field={{ ...f, searchable: f.options.length > 8 }} onChange={f.onChange} />}
                </section>
              );
            })}
          </div>
          <div className={pop.ffoot}>
            <button type="button" onClick={onClearAll}>Clear all</button>
            <span />
            <button type="button" className={pop.go} onClick={onClose}>Done</button>
          </div>
        </div>
      )}
    </div>
  );
}
